// extracted by mini-css-extract-plugin
export default {"ns_table_no_data":"NSNoData_ns_table_no_data__l9P9+"};